import { createFileRoute } from "@tanstack/react-router";
import { Link } from "@tanstack/react-router";
import { CTABand } from "@/components/site/CTABand";
import { PhoneButton } from "@/components/site/PhoneButton";
import blogHero from "@/assets/blog-hero.webp";
import { POSTS } from "@/lib/blog";

export const Route = createFileRoute("/blog")({
  head: () => ({
    meta: [
      { title: "Phoenix Plumbing Blog | Tips & Local Plumbing Advice" },
      { name: "description", content: "Plumbing tips, troubleshooting, and Phoenix-specific advice from a licensed local plumber. Call 602-834-1208 for service." },
      { property: "og:title", content: "Phoenix Plumbing Blog | Tips & Local Plumbing Advice" },
      { property: "og:description", content: "Plumbing tips, troubleshooting, and Phoenix-specific advice from a licensed local plumber. Call 602-834-1208 for service." },
      { property: "og:url", content: "https://www.phoenixplumbing.co/blog" },
      { name: "twitter:title", content: "Phoenix Plumbing Blog | Tips & Local Plumbing Advice" },
      { name: "twitter:description", content: "Plumbing tips, troubleshooting, and Phoenix-specific advice from a licensed local plumber. Call 602-834-1208 for service." },
    ],
    links: [{ rel: "canonical", href: "https://www.phoenixplumbing.co/blog" }],
  }),
  component: Page,
});

function Page() {
  return (
    <>
      <section className="relative bg-secondary text-secondary-foreground overflow-hidden">
        <div aria-hidden className="absolute inset-0 opacity-40 bg-cover bg-center" style={{ backgroundImage: `url(${blogHero})` }} />
        <div aria-hidden className="absolute inset-0 bg-gradient-to-r from-secondary via-secondary/80 to-secondary/50" />
        <div className="relative mx-auto max-w-4xl px-4 py-14">
          <h1 className="text-4xl md:text-5xl font-extrabold">Phoenix Plumbing Blog</h1>
          <p className="mt-4 text-secondary-foreground/90 text-lg">Plumbing tips, troubleshooting, and Phoenix-specific advice from a licensed local plumber. Call 602-834-1208 for service.</p>
          <div className="mt-6"><PhoneButton size="lg" /></div>
        </div>
      </section>
      <article className="mx-auto max-w-3xl px-4 py-12 prose prose-lg">
        <p>Browse our latest articles on Phoenix-area plumbing — hard water, slab leaks, water heaters, sewer issues, and more.</p>
      </article>
      <section className="mx-auto max-w-4xl px-4 pb-16">
        <h2 className="text-2xl font-extrabold text-secondary mb-6">All Articles</h2>
        <ul className="space-y-6">
          {[...POSTS]
            .sort((a, b) => (a.date < b.date ? 1 : -1))
            .map((post) => (
              <li key={post.slug} className="border-b border-border pb-6">
                <Link
                  to={`/${post.slug}` as any}
                  className="block group"
                >
                  <h3 className="text-xl font-bold text-secondary group-hover:text-primary transition-colors">
                    {post.title}
                  </h3>
                  <p className="mt-1 text-sm text-muted-foreground">
                    {new Date(post.date).toLocaleDateString("en-US", { year: "numeric", month: "long", day: "numeric" })}
                  </p>
                  <p className="mt-2 text-muted-foreground">{post.excerpt}</p>
                  <span className="mt-2 inline-block text-primary font-semibold">Read more →</span>
                </Link>
              </li>
            ))}
        </ul>
      </section>
      <CTABand />
    </>
  );
}
